import * as StudiesConstants from '../constants/Studies';
import {filter} from 'underscore';

const initialState = {
  collection: [],
  isFetching: false,
  isDeleting: false,
  isDirty: false,
  sorting: {
    sort: 'asc',
    order: 'status',
    query: ''
  },
  pagination: {
    total: 0,
    perPage: 10,
    totalPages: 0,
    page: 0
  }
};

export function systemStudies(state = initialState, action) {
  switch (action.type) {
    case StudiesConstants.SYSTEM_STUDIES_FETCH_STARTED:
      return Object.assign({}, state, {isFetching: true});
    case StudiesConstants.SYSTEM_STUDIES_FETCH_COMPLETED:
      return Object.assign({}, state, {
        collection: action.studies,
        pagination: action.pagination,
        sorting: action.sorting,
        isFetching: false,
        isDirty: false
      });
    case StudiesConstants.SYSTEM_STUDY_DELETE_STARTED:
      return Object.assign({}, state, {isDeleting: true});
    case StudiesConstants.SYSTEM_STUDY_DELETE_COMPLETED: {
      const newStudies = filter(state.collection, (study) => study.id !== action.study.id);

      return Object.assign({}, state, {collection: newStudies, isDeleting: false});
    }
    case StudiesConstants.SYSTEM_STUDY_SET_DIRTY:
      return Object.assign({}, state, {isDirty: action.dirty});
    default:
      return state;
  }
}
